export class LikeableTypeConfig {

  constructor(
    identifier:string,
  ){
    this.identifier = identifier
  }

  public identifier:string = null

}